const menu = {
    add: 'menu/add',
    update: 'menu/update',
    remove: 'menu/remove',
    getall: 'menu/getall',
    get: 'menu/get',
    getlist: 'menu/getlist',
}
export default menu
